module.exports = __webpack_public_path__ + "static/media/Coolmore_dark.8e4d6eb5.png";